import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";
import { featurePaths } from "@feature/constants/paths.constant";
import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";

const HelloWorldPage = lazy(() => import("@feature/pages/HelloWorld"));

@injectable()
@registry([{ token: FeatureToken, useClass: HelloWorld }])
class HelloWorld implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Hello World",
                path: featurePaths.Index,
                page: HelloWorldPage
            }
        ]
    };
}
